import {  inject } from 'vue'
export default function useLng(ns) {
    // const instance = getCurrentInstance()
    // const app = instance?.appContext
    // const $globalizationIns = app.config.globalProperties.$globalizationIns
    let  globalizationIns = inject("$globalizationIns");
    if (!globalizationIns) {
        globalizationIns = window.siteGlobalization;
    }
    if (!globalizationIns) {
        console.error(`Please provide $options globalizationIns  `)
    }
    const $t = function(key, ...args) {
        if (!key || !globalizationIns) {
            return '';
        }
        const nsKey = key.split(':');
        if (nsKey.length > 1) {
            //key with namespace
            return globalizationIns.$t(key, ...args);
        }

        if (!ns) {
            console.error(`Please provide $options i18next ns  `)
        }
        return globalizationIns.$st(
            ns,
            key,
            ...args
        );
    }
    return $t
}


/**

import useLng from '@/hooks/useLng';
const $t = useLng('md-testimonial');
 */